import colors from '@/theme/colors';
import { css } from '@emotion/css';

const UserAlreadyExistsError = () => (
  <span className={styles.error}>
    An account with that email address already exists. <a href="/login">Try logging in.</a>
  </span>
);

const styles = {
  error: css`
    color: ${colors.dragon};
    & > a {
      color: ${colors.jungle} !important;
      text-decoration: underline;
      cursor: pointer;
    }
  `,
};

export default UserAlreadyExistsError;
